import { render, staticRenderFns } from "./CreateClassroom.vue?vue&type=template&id=1a8ebabc&scoped=true&"
import script from "./CreateClassroom.vue?vue&type=script&lang=js&"
export * from "./CreateClassroom.vue?vue&type=script&lang=js&"
import style0 from "./CreateClassroom.vue?vue&type=style&index=0&id=1a8ebabc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a8ebabc",
  null
  
)

export default component.exports